import pushToDataLayer, { EVENTS } from '../../utilities/dataLayer';
import {
    BRANDS,
    FullCardIcon,
    ListItem,
    Modal,
    Paragraph,
    ShieldIcon,
    Text,
    ThumbsUpIcon,
    useBrand
} from '@cof/plastic-components';
import ModalLink from '../ModalLink/ModalLink';
import PropTypes from 'prop-types';
import { useState } from 'react';

const getIcon = (key) => {
    switch (key) {
        case 'Shield':
            return ShieldIcon;
        case 'FullCard':
            return FullCardIcon;
        case 'ThumbsUp':
            return ThumbsUpIcon;
        default:
            return () => <></>;
    }
};

const InstantIssuanceModal = ({ text, modalOpen, setModalOpen, reasonIndex }) => (
    <Modal
        heading={text({ path: `Reason${reasonIndex}.Header` })}
        Icon={getIcon(text({ path: `Reason${reasonIndex}.Icon` }))}
        isOpen={modalOpen}
        id={`reason-${reasonIndex}`}
        onClose={() => setModalOpen(false)}
        ariaDescribedById={`reason-${reasonIndex}-description`}
        data-qa-id={`reason-${reasonIndex}-modal`}
    >
        <Paragraph>{text({ path: `Reason${reasonIndex}.Text1` })}</Paragraph>
        <Paragraph>{text({ path: `Reason${reasonIndex}.Text2` })}</Paragraph>
    </Modal>
);

InstantIssuanceModal.propTypes = {
    text: PropTypes.func.isRequired,
    modalOpen: PropTypes.number.isRequired,
    setModalOpen: PropTypes.func.isRequired,
    reasonIndex: PropTypes.number.isRequired
};

const Reason = ({ text, iconColors, isInstantIssuance, reasonIndex }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const modalOnClick = (reasonIndex) => {
        pushToDataLayer({
            event: EVENTS.MODAL_OPEN,
            modalName: text({ path: `Reason${reasonIndex}.Header` })
        });
        setModalOpen(true);
    };
    const brand = useBrand();
    const Icon = getIcon(text({ path: `Reason${reasonIndex}.Icon` }));
    return (
        <>
            <ListItem
                Icon={() => <Icon color={iconColors} height={['2.4rem', '3.2rem']} width={['2.4rem', '3.2rem']} />}
                data-qa-id={`reason-${reasonIndex}`}
                icon
                marginBottom={[0, 0]}
            >
                {isInstantIssuance ? (
                    <ModalLink
                        onClick={() => modalOnClick(reasonIndex)}
                        modalName={text({ path: `Reason${reasonIndex}.Header` })}
                        aria-label={`${text({ path: `Reason${reasonIndex}.Header` })}`}
                        variant={brand === BRANDS.CAPITAL_ONE ? 'light' : 'dark'}
                        data-qa-id={`reason-${reasonIndex}-modal-link`}
                        data-qm-allow
                    >
                        {text({ path: `Reason${reasonIndex}.Header` })}
                    </ModalLink>
                ) : (
                    <Text
                        color={brand === BRANDS.CAPITAL_ONE && 'global.white'}
                        fontSize={['textMediumMobile', null, 'textLargeDesktop']}
                        fontWeight={'medium'}
                        data-qa-id={`reason-${reasonIndex}-text`}
                        data-qm-allow
                    >
                        {text({ path: `Reason${reasonIndex}.Header` })}
                    </Text>
                )}
            </ListItem>
            {isInstantIssuance && (
                <InstantIssuanceModal
                    text={text}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    reasonIndex={reasonIndex}
                />
            )}
        </>
    );
};

Reason.propTypes = {
    text: PropTypes.func.isRequired,
    iconColors: PropTypes.objectOf(PropTypes.string).isRequired,
    isInstantIssuance: PropTypes.bool,
    reasonIndex: PropTypes.number.isRequired
};

export default Reason;
